import { i18n } from '../i18n/translate.js';

var reactifiPageTitle = function reactifiPageTitle(title) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Foundry - %s';
  /* i18next-extract-disable-next-line */

  document.title = i18n.t(prefix, {
    postProcess: 'sprintf',
    sprintf: [title]
  });
};

export { reactifiPageTitle };